module.exports = "<div class=direction-navigator> <i ng-if=!$ctrl.isClickLeft ng-click=$ctrl.onClickLeft() class=\"fa fa-chevron-circle-left\"></i> <i ng-if=$ctrl.isClickLeft class=\"fa fa-spinner fa-spin\"></i> {{ $ctrl.displayValue }} <i ng-if=!$ctrl.isClickRight ng-click=$ctrl.onClickRight() class=\"fa fa-chevron-circle-right\"></i> <i ng-if=$ctrl.isClickRight class=\"fa fa-spinner fa-spin\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/direction-navigator/direction-navigator.html
// module id = 340
// module chunks = 0